<template>

  <div>

     <list-filters
      :trigger-filter.sync="triggerFilter"
      :data-filter.sync="dataFilter"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Tampilkan</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entri</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
          <div class="d-flex align-items-center justify-content-end">
              <h6 class="mr-1" v-if="attr != 'm4h5s5523' && attr != 'a4d5m5221'">Lihat Data Sebagai</h6>
              <v-select
                v-if="attr != 'm4h5s5523' && attr != 'a4d5m5221'"
                v-model="searchQuery"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="lihatSebagaiOptions.options"
                class="w-50"
                :reduce="val => val.value"
                :clearable="false"
                placeholder="Lihat Sebagai"
              />
              <!-- <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Pencarian..."
              /> -->
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchDatas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        :sort-desc.sync="isSortDirDesc"
        style="text-align:center;"
      >

        <!-- Column: User -->
        <template #cell(status)="data">
          <b-media vertical-align="center">
              <b-badge pill :variant="'light-'+data.item.color" >{{ data.item.status }}</b-badge>
          </b-media>
        </template>

        <template #cell(catatan)="data">
          <b-media vertical-align="center">
              <b-badge pill :variant="'light-danger'" >{{ data.item.catatan }}</b-badge>
          </b-media>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="d-flex justify-content-center">
            <!-- // Updated by Rio Ramadhan date: comment: button untuk role mahasiswa -->
            <b-button class="btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'pengajuan-sidang-edit', params: { uuid: data.item.uuid } }" title="Ubah Data"
            v-if="data.item.status == 'Perbaikan' && $can('edit', 'pengajuan-sidang')"
            >
              <feather-icon icon="EditIcon" />
            </b-button>

            <b-button
              class="btn-icon btn btn-relief-primary"
              variant="outline-danger"
              @click="deleteData(data.item.uuid)"
              v-if="data.item.status == 'Draft' && $can('delete', 'pengajuan-sidang')"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>

            <b-button v-if="data.item.status != 'Perbaikan' && $can('detail-btn', 'pengajuan-sidang') && (data.item.is_pembimbing != true && data.item.is_penguji != true)" class="ml-1 btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'pengajuan-sidang-readonly', params: { uuid: data.item.uuid } }" title="Lihat Data">
              <feather-icon icon="SearchIcon" />
            </b-button>

            <!-- // Updated by Rio Ramadhan date: comment: button untuk role selain mahasiswa -->
            <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'pengajuan-sidang-readonly', params: { uuid: data.item.uuid } }" title="Lihat Data"
            v-if="$can('manage','all') || (data.item.status == 'Menunggu Konfirmasi Pembimbing' && data.item.is_pembimbing == true && $can('detail-btn', 'pengajuan-sidang'))"
            >
              <feather-icon icon="SearchIcon" />
            </b-button>

            <b-button class="ml-1 mr-1 btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'pengajuan-sidang-readonly', params: { uuid: data.item.uuid } }" title="Lihat Data"
            v-if="$can('manage', 'all-content') && data.item.status == 'Menunggu Konfirmasi Admin'"
            >
              <feather-icon icon="SearchIcon" />
            </b-button>

            <b-button class="ml-1 mr-1 btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'pengajuan-sidang-readonly', params: { uuid: data.item.uuid } }" title="Lihat Data"
            v-if="$can('set-ruangan-sidang', 'pengajuan-sidang') && data.item.status == 'Pencarian Ruangan'"
            >
              <feather-icon icon="SearchIcon" />
            </b-button>

            <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'pengajuan-sidang-readonly', params: { uuid: data.item.uuid } }" title="Lihat Data"
            v-if="$can('dekanat', 'pengajuan-sidang') && data.item.status == 'Menunggu Konfirmasi Dekanat'"
            >
              <feather-icon icon="SearchIcon" />
            </b-button>
          </div>           
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Tampilkan {{ dataMeta.from }} hingga {{ dataMeta.to }} dari {{ dataMeta.of }} entri</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  deletePengajuanSidang
} from '@/connection-api/master'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/connection-api/daftar-sidang/storeModule'
import useList from '@/connection-api/daftar-sidang/list'
import listFilters from './ListFilters.vue'

export default {
  components: {
    listFilters,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    // BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    BBadge,

    vSelect,
  },
  data() {
    return {
      attr: null,
      jenisUptOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis UPT --' },
        ],
      },
      kanwilOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Kanwil --' },
        ],
      },
      uptOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih UPT --' },
        ],
      },
      jenisAssetOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Asset --' },
        ],
      },
      statusAssetOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Asset --' },
        ],
      },
      lihatSebagaiOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Lihat Sebagai --' },
          { value: 'pembimbing', label: 'Pembimbing' },
          { value: 'penguji', label: 'Penguji' },
        ],
      },
    }
  },
  async mounted() {
    this.searchQuery = 'pembimbing'
    const userDataString = localStorage.getItem('userData')
    const userDataArray = JSON.parse(userDataString)
    this.attr = userDataArray.attr
  },
  methods: {
    async deleteData(id){
      if (confirm('Anda yakin ingin menghapus data ini?')) {
        // Save it!
        const response = await deletePengajuanSidang(id)
        if(response.data.success === true){
          this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Pengajuan Sidang',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Data berhasil di hapus',
              },
            })
            this.refetchData()
        }else{
          this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Pengajuan Sidang',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: 'Data gagal di hapus',
              },
            })
        }
      }
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'daftar-sidang'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      triggerFilter,
      dataFilter,
    } = useList()

    return {

      // Sidebar
      isAddNewUserSidebarActive,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      triggerFilter,
      dataFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
